import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {ExternalWork} from "../../models/contractor/ExternalWork";
import {Nullable} from "../../models/common/Nullable";
import {
    ExternalWorkActionTypes,
    CREATE_EXTERNAL_WORK, CREATE_EXTERNAL_WORK_ERROR, CREATE_EXTERNAL_WORK_SUCCESS,
    UPDATE_EXTERNAL_WORK, UPDATE_EXTERNAL_WORK_ERROR,UPDATE_EXTERNAL_WORK_SUCCESS,
    DELETE_EXTERNAL_WORK, DELETE_EXTERNAL_WORK_ERROR, DELETE_EXTERNAL_WORK_SUCCESS,
    FETCH_EXTERNAL_WORK_BY_ID, FETCH_EXTERNAL_WORK_BY_ID_ERROR,FETCH_EXTERNAL_WORK_BY_ID_SUCCESS,
    FETCH_EXTERNAL_WORKS, FETCH_EXTERNAL_WORKS_ERROR,FETCH_EXTERNAL_WORKS_SUCCESS,
    RESTORE_EXTERNAL_WORK, RESTORE_EXTERNAL_WORK_ERROR, RESTORE_EXTERNAL_WORK_SUCCESS
} from "../../actions/contractors/ExternalWorkActions";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";

export interface ExternalWorkState extends BasicReducerState< Nullable< ExternalWork[] >, Nullable< ExternalWork > > {

}

export function ExternalWorkReducer(
    state: ExternalWorkState = initialReducerState(),
    action: ExternalWorkActionTypes
) {

    switch ( action.type ) {
        case FETCH_EXTERNAL_WORKS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_EXTERNAL_WORKS_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_EXTERNAL_WORKS_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_EXTERNAL_WORK_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWorkId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_EXTERNAL_WORK_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWork.externalWorkId.rawValue ]: {
                        entry: action.externalWork,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_EXTERNAL_WORK_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWorkId.rawValue ]: {
                        ...state.detailedEntries[ action.externalWorkId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_EXTERNAL_WORK:
        case UPDATE_EXTERNAL_WORK:
        case DELETE_EXTERNAL_WORK:
        case RESTORE_EXTERNAL_WORK:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_EXTERNAL_WORK_SUCCESS:
        case UPDATE_EXTERNAL_WORK_SUCCESS:
        case DELETE_EXTERNAL_WORK_SUCCESS:
        case RESTORE_EXTERNAL_WORK_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_EXTERNAL_WORK_ERROR:
        case UPDATE_EXTERNAL_WORK_ERROR:
        case DELETE_EXTERNAL_WORK_ERROR:
        case RESTORE_EXTERNAL_WORK_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };

        default:
            return state;
    }

}